var MarkdownNodeType;
(function (MarkdownNodeType) {
  MarkdownNodeType["BLOCK_QUOTE"] = "block_quote";
  MarkdownNodeType["CODE_BLOCK"] = "code_block";
  MarkdownNodeType["CODE"] = "code";
  MarkdownNodeType["EMPH"] = "emph";
  MarkdownNodeType["HEADING"] = "heading";
  MarkdownNodeType["HTML_BLOCK"] = "html_block";
  MarkdownNodeType["HTML_INLINE"] = "html_inline";
  MarkdownNodeType["IMAGE"] = "image";
  MarkdownNodeType["ITEM"] = "item";
  MarkdownNodeType["LINEBREAK"] = "linebreak";
  MarkdownNodeType["LINK"] = "link";
  MarkdownNodeType["LIST"] = "list";
  MarkdownNodeType["PARAGRAPH"] = "paragraph";
  MarkdownNodeType["SOFTBREAK"] = "softbreak";
  MarkdownNodeType["STRONG"] = "strong";
  MarkdownNodeType["THEMATIC_BREAK"] = "thematic_break";
})(MarkdownNodeType || (MarkdownNodeType = {}));

export { MarkdownNodeType };
//# sourceMappingURL=markdownNodeType.mjs.map
